export enum ChatScreenNames {
  MAIN = 'chat',
  ROOMS_LIST = 'rooms_list',
  ROOM = 'room',
}
